<template>
  <div id="rate-assist-search-header">
    <form @submit.prevent="searchNow">
      <div class="shadow clearfix bg-15">
        <div class="row">
          <div class="col-xs-12">
            <hr class="hr-text" data-content="Search Lookup Profiles"/>
          </div>
          <div class="col-xs-12 col-md-9">
            <div class="col-xs-12 col-md-3">
              <div class="form-group">
                <label for="search-by" class="form-label">Search by:</label>
                <select id="search-by" class="form-control" v-model="searchBy">
                  <option value="description">Description</option>
                  <option value="serviceContract">Service Contract</option>
                  <option value="serviceProvider">Provider</option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 col-md-9">
              <div class="form-group" v-if="searchBy === 'description'">
                <label for="search-by-desc" class="form-label">Description</label>
                <input type="text" class="form-control" id="search-by-desc" v-model="search.description"/>
              </div>
              <div class="form-group" v-if="searchBy === 'serviceContract'">
                <label for="search-by-sc" class="form-label">Service Contract</label>
                <input type="text" class="form-control" id="search-by-sc" v-model="search.serviceContract"/>
              </div>
              <div class="form-group" v-if="searchBy === 'serviceProvider'">
                <label for="search-by-provider" class="form-label">Service Provider</label>
                <autocomplete
                  :dataset="partySearchResults"
                  title="Just start typing!"
                  placeHolder="Select a Service Provider"
                  :initVal="search.serviceProvider"
                  v-on:changing="data => partySearchText = data"
                  :fnFormatText="displayParty"
                  :fnSelectValue="displayParty"
                  v-on:selection-made="updateServiceProvider"
                  :autoFocus="true"
                />
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3 mt-25">
            <div class="col-xs-6">
              <div class="btn sq btn-primary btn-fw-sm" @click="searchNow">
                Search <i class="fa fa-search"></i>
              </div>
            </div>
            <div class="col-xs-6">
              <div class="btn sq btn-success btn-fw-sm" @click="goToNew">
                Add New <i class="fa fa-plus"></i>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <hr>
          </div>
        </div>
      </div>
      <input type="submit" style="display:none"/>
    </form>
  </div>
</template>
<script>
  import Autocomplete from '../../helpers/AutoComplete'
  import LookupHelperMixin from '../../admin/mixins/Helpers'
  import { cryptQueryString, transformQueryString } from '../../helpers/RouteHash'
  import event from '../../../event'
  export default {
    name: 'SearchHeader',
    mixins: [ LookupHelperMixin ],
    components: {
      Autocomplete
    },
    data () {
      return {
        searchBy: 'description',
        search: {
          description: '',
          serviceProvider: null,
          serviceContract: ''
        }
      }
    },
    computed: {
      params () {
        let obj = {}
        obj[this.searchBy] = this.search[this.searchBy]
        return obj
      },
      transformedParams () {
        return transformQueryString(this.params)
      },
      canSearch () {
        return Object.keys(this.transformedParams).length > 0 &&
              this.transformedParams[this.searchBy] !== null &&
              this.transformedParams[this.searchBy].length > 0
      }
    },
    methods: {
      updateServiceProvider (party) {
        this.search.serviceProvider = party
        this.partySearchText = ''
        this.partySearchResults = []
      },
      goToNew () {
        this.$router.push({ name: 'RateAssist' })
      },
      searchNow () {
        if (this.canSearch) {
          this.$router.push({ name: 'RateAssist - Search Results', query: cryptQueryString(this.transformedParams) })
        } else {
          event.$emit('toast', { type: 'warning', message: 'Ensure you refine your search criteria.' })
        }
      }
    }
  }
</script>
<style>
#rate-assist-search-header {
  padding: 15px;
}
.btn-fw-sm {
  width: 99%;
}
.mt-25 {
  margin-top: 25px;
}
.bg-15 {
  background-color: #fff;
}

/* Large Devices, Wide Screens */
@media only screen and (max-width : 1200px) {

}

/* Medium Devices, Desktops */
@media only screen and (max-width : 992px) {
}

/* Small Devices, Tablets */
@media only screen and (max-width : 768px) {

}

/* Extra Small Devices, Phones */
@media only screen and (max-width : 480px) {

}

/* Custom, iPhone Retina */
@media only screen and (max-width : 320px) {

}
</style>



// WEBPACK FOOTER //
// src/modules/rateassist/components/SearchHeader.vue